var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"isLoading":_vm.loading,"items":_vm.items,"fields":_vm.fields,"options":_vm.menuItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }